var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('QrCodeScanComponent',{on:{"scan-result":_vm.onDecode}}),_c('div',{staticStyle:{"margin":"10px"}},[_vm._v(" SCAN RESULT: "+_vm._s(_vm.result)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }